import { render } from "./class-manage.vue?vue&type=template&id=613e0a42"
import script from "./class-manage.vue?vue&type=script&lang=js"
export * from "./class-manage.vue?vue&type=script&lang=js"

import "./class-manage.vue?vue&type=style&index=0&id=613e0a42&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__